<template>
  <div
    :class="[
      'accordion cursor-pointer ',
      this.show ? 'cp-bg-white' : 'cp-bg-gray-100',
    ]"
  >
    <div
      :class="[
        'header cp-flex cp-justify-between cp-align-middle cp-items-center ',
        enabled() ? 'cp-cursor-pointer' : '',
      ]"
      v-on:click="toggle"
    >
      <slot name="header"></slot>
      <font-awesome-icon
        icon="times"
        :class="['cp-text-grey-400', closeRotate]"
        v-show="enabled()"
      />
    </div>
    <transition
      name="accordion"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
    >
      <div class="body cp-bg-white" v-show="show">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<style>
.accordion .body {
  overflow: hidden;
  transition: 150ms ease-out;
}

.fa-rotate-45 {
  transform: rotate(45deg);
}
</style>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  computed: {
    closeRotate() {
      return this.show ? "fa-rotate-90" : "fa-rotate-45";
    },
    closeState() {
      return [this.show ? "cp-bg-gray-900" : "cp-bg-gray-300"];
    },
    closeIcon() {
      return "fas fa-times";
    },
  },
  methods: {
    toggle: function () {
      if (this.enabled()) {
        this.show = !this.show;
      }
    },
    enabled: function () {
      return this.$slots.default[0].children;
    },
    // enter: function(el, done) {
    //   $(el).slideDown(150, done);
    // },
    // leave: function(el, done) {
    //   $(el).slideUp(150, done);
    // },
    beforeEnter: function (el) {
      el.style.height = "0";
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function (el) {
      el.style.height = "0";
    },
  },
};
</script>
